import React, { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { platformSelectors, hasActiveFeatureFlag } from '@clatter/platform';
import { FeatureUnavailable } from '../FeatureUnavailable/FeatureUnavailable';

interface FeatureFlagGuardProps {
  flagName: string;
  fallback?: ReactNode;
  children?: ReactNode;
}

export const FeatureFlagGuard: FC<FeatureFlagGuardProps> = ({
  flagName,
  fallback = <FeatureUnavailable />,
  children,
}) => {
  const featureFlags = useSelector(platformSelectors.featureFlag.selectAllFeatureFlags);
  const loadingStatus = useSelector(platformSelectors.featureFlag.loadingStatus);

  // flags still loading — render nothing until resolved
  if (loadingStatus === 'not loaded' || loadingStatus === 'loading') {
    return null;
  }

  const isEnabled = hasActiveFeatureFlag({ featureFlags, flagName });

  return isEnabled ? <>{children}</> : <>{fallback}</>;
};
